/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * Reducer
 * @function UsersCreatedReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeUsersCreatedAction } action: action de
 *     l'application
 * @return { Reducer }
 */
export const UsersCreatedReducer: Reducer<CombinesObjectModels<any>> =
    (state: any = {

     }, action: actionsTypesFromStore.TypeUsersCreatedAction) => {
      switch (action.type) {
        case actions.UsersCreatedActionTypes.USERSCREATED_INPROGRESS:

          return {
            loading: true, ...state
          }

          break;
        case actions.UsersCreatedActionTypes.USERSCREATED_FAIL:

          return {
            error: action.payload.error, loading: false,
          }

          break;

        case actions.UsersCreatedActionTypes.USERSCREATED_SUCCESS:

          return {
            data: action.payload.data, loading: false,
          }

          break;

        default:
          return state
          break;
      }
    }


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/administration/users/created/index.ts